import { httpClient } from "./httpClient";

type LandingZoneRole = {
  id: number;
  landingZoneRoleName: string;
  isActive: boolean;
};

type Data = {
  landingZoneRoles: LandingZoneRole[];
};

export async function getActiveLandingZoneRoles(): Promise<LandingZoneRole[]> {
  try {
    const { data } = await httpClient.get<Data>(
      `/api/v1/landing-zone-roles/active`
    );

    return data.landingZoneRoles;
  } catch (error) {
    throw error;
  }
}
